import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Мужская футболка стрейч выполнена из разновидности хлопкового полотна — стрейч. Хлопок-стрейч — лёгкий и в тоже время прочный материал, который состоит на 95% из хлопка и на 5% из эластана. Особенностью этой ткани является ее эластичность, за счет вплетения в ткань резиновой нити, благодаря которой она прекрасно держит заданную форму. Благодаря добавлению эластичных волокон она практически не мнётся, стрэйч-футболки красиво облегают фигуру. Эта ткань очень практична летом. Плотность материала 200гр/м<sup>2</sup>.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`man_stretch_tee`],
      sizeInfo: `man_stretch_tee`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
